// extracted by mini-css-extract-plugin
export var children = "styles-module--children--6721a";
export var layout = "styles-module--layout--f2a30";
export var title = "styles-module--title--3b30c";